import Alpine from 'alpinejs';
import Typed from 'typed.js';

document.addEventListener('alpine:init', () => {
  Alpine.data('typedText', () => ({
    init() {
      new Typed(this.$refs.typedJs, {
        stringsElement: this.$refs.items,
        typeSpeed: 50,
        backSpeed: 50,
        backDelay: 5000,
        loop: true,
        cursorChar: '_',
      });
    },
  }));
});
